import React, {useEffect} from "react";
import Layout from "../Components/Layout";
import WOW from 'wowjs';
import 'animate.css';

function TermsConditions() {
   useEffect(() => {
    new WOW.WOW({
      live: false, // Disable live updates (improves performance)
    }).init();
  }, []);

  return (
    <Layout>
      <div className="container my-5">
        <h1 className="mb-4 text-center wow animate__animated animate__slideInLeft">Terms and Conditions</h1>

        <p>
          Welcome to Haramayn Rooms. By accessing and using our website <a href="https://haramaynrooms.com" target="_blank" rel="noreferrer">haramaynrooms.com</a> and services, you agree to comply with the
          following Terms and Conditions. Please read them carefully before
          proceeding
        </p>

        <h4 className="wow animate__animated animate__fadeInUp">1-Use of the Platform</h4>

        <ul className="square-list lh-lg wow animate__animated animate__fadeInUp">
          <li>
            The platform is intended for registered travel agents and businesses
            only.
          </li>
          <li>
            Users must provide accurate and up-to-date information during
            registration and booking.
          </li>
          <li>
            Unauthorized use, fraudulent bookings, or misuse of the platform is
            strictly prohibited.
          </li>
        </ul>

        <h4 className="wow animate__animated animate__fadeInUp">2-Booking Policy</h4>
        <ul className="square-list lh-lg wow animate__animated animate__fadeInUp">
          <li>
            All bookings made through Haramayn Rooms are subject to hotel
            availability and partner confirmation.
          </li>
          <li>
            Prices displayed are based on real-time availability and may change
            without prior notice.
          </li>
          <li>
            It is the responsibility of the agent to verify booking details
            (guest names, dates, room types) before confirming.
          </li>
        </ul>
        <h4 className="wow animate__animated animate__fadeInUp">3-Payment Terms</h4>
        <ul className="square-list lh-lg wow animate__animated animate__fadeInUp">
          <li>
            Payments must be made through the approved methods available on the
            platform.
          </li>
          <li>
            Bookings are confirmed only after full or agreed payment has been
            received.
          </li>
          <li>
            Any additional charges (taxes, city fees, extras) may be collected
            directly by the hotel.
          </li>
        </ul>
        <h4 className="wow animate__animated animate__fadeInUp">4-Cancellations & Refunds</h4>
        <ul className="square-list lh-lg wow animate__animated animate__fadeInUp">
          <li>
            Cancellation policies vary by hotel and will be displayed at the
            time of booking.
          </li>
          <li>
            Refunds, if applicable, will follow the hotel partner’s policy.
          </li>
          <li>
            Haramayn Rooms is not liable for refunds outside of the stated
            cancellation terms.
          </li>
        </ul>
        <h4 className="wow animate__animated animate__fadeInUp">5-Privacy & Data Protection</h4>
        <ul className="square-list lh-lg wow animate__animated animate__fadeInUp">
          <li>
            User information is collected and processed in accordance with our
            Privacy Policy.
          </li>
          <li>
            By using the platform, you consent to the use of your data as
            described.
          </li>
        </ul>
        <h4 className="wow animate__animated animate__fadeInUp">6-User Responsibilities</h4>
        <ul className="square-list lh-lg wow animate__animated animate__fadeInUp">
          <li>
            Travel agents are responsible for providing correct guest
            information.
          </li>
          <li>
            It is the responsibility of the client to have valid travel
            documents, visas, and insurance.
          </li>
          <li>
            Haramayn Rooms will not be liable for denied check-in or travel
            issues due to missing documentation.
          </li>
        </ul>
      </div>
    </Layout>
  );
}

export default TermsConditions;
